import { atom } from 'jotai';
import type { TaskDefinition } from '@src/scenario-editor/render-utils/types';

export const tasksAtom = atom<TaskDefinition[]>([]);
